import { TFunction } from "i18next";
import { ECONTRACT_STATUS } from "../../../enums";

export const GET_MILESTONE_STATUSES = (
  t: TFunction<"translation", undefined>
) => ({
  seller: {
    [ECONTRACT_STATUS.DRAFT]: {
      backgroundColor: "#EEF0F5",
      logo: "/assets/images/svg/active.svg",
      title: t("lbl_draft"),
      subTitle: t("lbl_waiting_for_buyer_payment"),
    },
    [ECONTRACT_STATUS.CREATED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/active.svg",
      title: t("lbl_active_contract"),
      subTitle: t("lbl_waiting_for_buyer_payment"),
    },
    [ECONTRACT_STATUS.SUBMITTED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/active.svg",
      title: t("lbl_active_contract"),
      subTitle: t("lbl_waiting_for_buyer_payment"),
    },
    [ECONTRACT_STATUS.ADDING_PARTY]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/active.svg",
      title: t("lbl_active_contract"),
      subTitle: t("lbl_waiting_for_buyer_payment"),
    },
    [ECONTRACT_STATUS.PARTIALLY_PAID]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/active.svg",
      title: t("lbl_active_contract"),
      subTitle: t("lbl_waiting_for_buyer_payment"),
    },
    [ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION]: {
      backgroundColor: "#EAB0010D",
      logo: "/assets/images/svg/waiting_approval.svg",
      title: t("lbl_active_contract"),
      subTitle: t("lbl_waiting_payment_confirmation"),
    },
    [ECONTRACT_STATUS.WAITING_FOR_DELIVERY]: {
      backgroundColor: "#5337C30A",
      logo: "/assets/images/svg/waitingDeliveryInstallment.svg",
      title: t("lbl_pay_installment"),
      subTitle: t("lbl_payment_installment_agreement"),
    },
    [ECONTRACT_STATUS.PARTIAL_CONFIRMED_DELIVERY]: {
      backgroundColor: "#5337C30A",
      logo: "/assets/images/svg/waitingDeliveryInstallment.svg",
      title: t("lbl_pay_installment"),
      subTitle: t("lbl_payment_installment_agreement"),
    },
    [ECONTRACT_STATUS.DELIVERY_ESCALATION]: {
      backgroundColor: "#D18B490D",
      logo: "/assets/images/svg/escalationIcon.svg",
      title: t("lbl_contract_details_waiting_for_escaltion_state_title"),
      subTitle: t("lbl_experts_working_on_escalation"),
    },
    [ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("lbl_escalation_done"),
      subTitle: t("lbl_escalation_done_for_buyer"),
    },
    [ECONTRACT_STATUS.PARTIALLY_REFUNDED]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("lbl_escalation_done"),
      subTitle: t("lbl_escalation_done_for_buyer"),
    },
    [ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("lbl_escalation_done"),
      subTitle: t("lbl_escalation_done_for_seller"),
    },
    [ECONTRACT_STATUS.PARTIALLY_RESOLVE_RELEASED]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("lbl_escalation_done"),
      subTitle: t("lbl_escalation_done_for_seller"),
    },
    [ECONTRACT_STATUS.ITEM_INSPECTION]: {
      backgroundColor: "rgba(99, 202, 250, 0.07)",
      logo: "/assets/images/svg/inspection.svg",
      title: t("lbl_contract_list_items_wating_for_inspection"),
      subTitle: t(
        "lbl_contract_details_item_inspection_state_seller_sub_title"
      ),
    },
    [ECONTRACT_STATUS.ITEM_ACCEPTED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altCompleted.svg",
      title: t("lbl_done_successfully"),
      subTitle: t("lbl_money_will_be_transferred"),
    },
    [ECONTRACT_STATUS.READY_FOR_CASH_OUT]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altCompleted.svg",
      title: t("lbl_done_successfully"),
      subTitle: t("lbl_money_will_be_transferred"),
    },
    [ECONTRACT_STATUS.PARTIALLY_RELEASED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altCompleted.svg",
      title: t("lbl_done_successfully"),
      subTitle: t("lbl_money_will_be_transferred"),
    },
    [ECONTRACT_STATUS.COMPLETED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altMoney.svg",
      title: t("lbl_money_has_been_transferred"),
      subTitle: t("lbl_money_transferred_to_bank_account"),
    },
    [ECONTRACT_STATUS.EXCEPTIONAL_COMPLETED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altMoney.svg",
      title: t("lbl_money_has_been_transferred"),
      subTitle: t("lbl_money_transferred_to_bank_account"),
    },
    [ECONTRACT_STATUS.CLOSED_REFUND_CUSTOMER]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("CLOSED_STATUS"),
      subTitle: t("lbl_closed_refund_buyer"),
    },
    [ECONTRACT_STATUS.CLOSED_RELEASE_PROVIDER]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("CLOSED_STATUS"),
      subTitle: t("lbl_closed_release_seller"),
    },
    [ECONTRACT_STATUS.CASH_OUT_APPROVED]: {
      backgroundColor: "#f3f6fc",
      logo: "/assets/images/svg/cashOutApproved_status.svg",
      title: t("lbl_money_being_transferred"),
      subTitle: t("status_transfer_subtitle"),
    },
    [ECONTRACT_STATUS.PARTIAL_CASHOUT]: {
      backgroundColor: "#f3f6fc",
      logo: "/assets/images/svg/cashOutApproved_status.svg",
      title: t("lbl_money_being_transferred"),
      subTitle: t("status_transfer_subtitle"),
    },
  },
  buyer: {
    [ECONTRACT_STATUS.CREATED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/active.svg",
      title: t("lbl_active_contract"),
      subTitle: t("lbl_waiting_for_the_payment"),
    },
    [ECONTRACT_STATUS.PARTIALLY_PAID]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/active.svg",
      title: t("lbl_active_contract"),
      subTitle: t("lbl_waiting_for_buyer_payment"),
    },
    [ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION]: {
      backgroundColor: "#EAB0010D",
      logo: "/assets/images/svg/waiting_approval.svg",
      title: t("lbl_active_contract"),
      subTitle: t("lbl_waiting_payment_confirmation"),
    },
    [ECONTRACT_STATUS.WAITING_FOR_DELIVERY]: {
      backgroundColor: "#5337C30A",
      logo: "/assets/images/svg/waitingDeliveryInstallment.svg",
      title: t("lbl_pay_installment"),
      subTitle: t("lbl_payment_installment_agreement"),
    },
    [ECONTRACT_STATUS.PARTIAL_CONFIRMED_DELIVERY]: {
      backgroundColor: "#5337C30A",
      logo: "/assets/images/svg/waitingDeliveryInstallment.svg",
      title: t("lbl_pay_installment"),
      subTitle: t("lbl_payment_installment_agreement"),
    },
    [ECONTRACT_STATUS.DELIVERY_ESCALATION]: {
      backgroundColor: "#D18B490D",
      logo: "/assets/images/svg/escalationIcon.svg",
      title: t("lbl_contract_details_waiting_for_escaltion_state_title"),
      subTitle: t("lbl_experts_working_on_escalation"),
    },
    [ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("lbl_escalation_done"),
      subTitle: t("lbl_escalation_done_for_buyer"),
    },
    [ECONTRACT_STATUS.PARTIALLY_REFUNDED]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("lbl_escalation_done"),
      subTitle: t("lbl_escalation_done_for_buyer"),
    },
    [ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("lbl_escalation_done"),
      subTitle: t("lbl_escalation_done_for_seller"),
    },
    [ECONTRACT_STATUS.PARTIALLY_RESOLVE_RELEASED]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("lbl_escalation_done"),
      subTitle: t("lbl_escalation_done_for_seller"),
    },
    [ECONTRACT_STATUS.ITEM_INSPECTION]: {
      backgroundColor: "rgba(99, 202, 250, 0.07)",
      logo: "/assets/images/svg/inspection.svg",
      title: t("lbl_contract_list_items_wating_for_inspection"),
      subTitle: t("lbl_contract_details_item_inspection_state_buyer_sub_title"),
    },
    [ECONTRACT_STATUS.ITEM_ACCEPTED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altCompleted.svg",
      title: t("lbl_done_successfully"),
      subTitle: t("lbl_money_will_be_transferred_to_provider"),
    },
    [ECONTRACT_STATUS.READY_FOR_CASH_OUT]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altCompleted.svg",
      title: t("lbl_done_successfully"),
      subTitle: t("lbl_money_will_be_transferred"),
    },
    [ECONTRACT_STATUS.PARTIALLY_RELEASED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altCompleted.svg",
      title: t("lbl_done_successfully"),
      subTitle: t("lbl_money_will_be_transferred_to_provider"),
    },
    [ECONTRACT_STATUS.COMPLETED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altMoney.svg",
      title: t("lbl_money_has_been_transferred"),
      subTitle: t("lbl_money_transferred_to_bank_account"),
    },
    [ECONTRACT_STATUS.EXCEPTIONAL_COMPLETED]: {
      backgroundColor: "#44C16E0D",
      logo: "/assets/images/svg/altMoney.svg",
      title: t("lbl_money_has_been_transferred"),
      subTitle: t("lbl_money_transferred_to_bank_account"),
    },
    [ECONTRACT_STATUS.CLOSED_REFUND_CUSTOMER]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("CLOSED_STATUS"),
      subTitle: t("lbl_closed_refund_buyer"),
    },
    [ECONTRACT_STATUS.CLOSED_RELEASE_PROVIDER]: {
      backgroundColor: "#00E0BF0D",
      logo: "/assets/images/svg/judge.svg",
      title: t("CLOSED_STATUS"),
      subTitle: t("lbl_closed_release_seller"),
    },
    [ECONTRACT_STATUS.CASH_OUT_APPROVED]: {
      backgroundColor: "#f3f6fc",
      logo: "/assets/images/svg/cashOutApproved_status.svg",
      title: t("lbl_money_being_transferred"),
      subTitle: t("status_transfer_subtitle"),
    },
    [ECONTRACT_STATUS.PARTIAL_CASHOUT]: {
      backgroundColor: "#f3f6fc",
      logo: "/assets/images/svg/cashOutApproved_status.svg",
      title: t("lbl_money_being_transferred"),
      subTitle: t("status_transfer_subtitle"),
    },
  },
});
